import React from 'react';
import type { Video, Settings } from '../types';

interface HeroVideoProps {
    video: Video;
    settings: Settings;
}

const HeroVideo: React.FC<HeroVideoProps> = ({ video, settings }) => {
    // Parameters for a seamless background video: autoplay, mute, loop, no controls, no info, modest branding, no related videos.
    // The `playlist` parameter is required for `loop=1` to work correctly.
    const videoSrc = `https://www.youtube.com/embed/${video.youtubeVideoId}?autoplay=1&mute=1&loop=1&playlist=${video.youtubeVideoId}&controls=0&showinfo=0&autohide=1&modestbranding=1&rel=0`;

    return (
        <div className="relative h-screen w-full overflow-hidden bg-brand-dark">
            <div className="absolute top-1/2 left-1/2 min-w-full min-h-full w-auto h-auto -translate-x-1/2 -translate-y-1/2 z-0">
                <iframe
                    src={videoSrc}
                    title={video.title}
                    frameBorder="0"
                    allow="autoplay; encrypted-media"
                    className="w-full h-full aspect-video pointer-events-none"
                ></iframe>
            </div>
            <div className="absolute inset-0 bg-black bg-opacity-60"></div>
            <div className="relative z-10 h-full flex items-center justify-center text-center text-white px-4">
                <div className="container mx-auto">
                    <h1 className="text-4xl md:text-6xl font-bold tracking-tight font-heading">{settings.slogan}</h1>
                    <p className="mt-4 text-lg md:text-xl text-gray-300 max-w-2xl mx-auto font-body">{settings.footerContent}</p>
                </div>
            </div>
        </div>
    );
};

export default HeroVideo;
